import { useState } from 'react';
import { Card, TextArea } from 'vopay';
import { Button } from 'UI';
import { Dialog } from '@/providers/Dialog.provider';
import { useTranslation } from 'react-i18next';
import styles from './RejectTransactionDialog.module.scss';
import ArticleIcon from './svgs/article.svg';

type RejectTransactionDialogProps = {
  onConfirm: (reason: string) => void;
  onCancel: () => void;
};

const RejectTransactionDialog = ({ onConfirm, onCancel }: RejectTransactionDialogProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Inbox.RejectTransactionDialog' });
  const [rejectionReason, setRejectionReason] = useState('');

  const handleConfirm = () => {
    onConfirm(rejectionReason);
  };

  return (
    <Card className={styles.dialogCard}>
      <img src={ArticleIcon} alt="Article" width={60} height={60} className={styles.iconContainer} />
      <Dialog.Title level="3">{t('title', { defaultValue: 'Confirm Transaction Rejection' })}</Dialog.Title>

      <div className={styles.formField}>
        <label className={styles.label}>{t('reasonLabel', { defaultValue: 'Rejection Reason' })}</label>

        <TextArea
          name="rejectionReason"
          value={rejectionReason}
          variant="outlineShadow"
          onChange={(e) => setRejectionReason(e.target.value)}
          onBlur={() => {}}
          placeholder={t('reasonPlaceholder', { defaultValue: 'Optional' })}
          rows={4}
        />
      </div>

      <div className={styles.buttonGroup}>
        <Button colorScheme="secondary" onClick={onCancel}>
          {t('cancelButton', { defaultValue: 'Cancel' })}
        </Button>

        <Button colorScheme="primary" onClick={handleConfirm}>
          {t('confirmButton', { defaultValue: 'Confirm & Reject' })}
        </Button>
      </div>
    </Card>
  );
};

export default RejectTransactionDialog;
